import type { UserPermission } from "@callcenter/services"

export const API_DEPRECATION_DEADLINE = new Date("2027-04-01T00:00:00Z")

export const API_DEPRECATION_DISMISSED_STORAGE_KEY = "apiDeprecationBannerDismissed"

export const API_DEPRECATION_REQUIRED_PERMISSIONS: ReadonlyArray<UserPermission> = [
  "edit_callcenters",
  "view_integrations",
  "edit_integrations",
  "view_api_keys",
  "create_api_keys",
  "edit_api_keys",
  "delete_api_keys",
  "view_users",
  "view_user_settings",
  "edit_acls",
  "edit_billing",
  "view_billing_units",
  "view_all_cdrs",
  "allow_manager_actions",
  "view_historical_reports"
]
